import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '@shared/models/api-response.model';
import { IpAddressModel } from '../model/ip-address.model';

@Injectable({
  providedIn: 'root'
})
export class IpAddressHttpService {

  constructor(
    private http: HttpClient
  ) { }

  getIpAddress(): Observable<IpAddressModel> {
    return this.http.get<ApiResponse>(`/getip`, { observe: 'response' }).pipe(
      map((res: HttpResponse<ApiResponse>) => {
        /* Access the X-Country-Code header */
        const country_code = res.headers.get('X-Country-Code');
        /* Add country_code to the response data */
        const responseData = res.body?.data?.rows || [];

        return { ...responseData, country_code };
      })
    );
  }
}
